export default __webpack_public_path__ + "static/media/thai-student.3f0e8de0.jpeg";